/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useMemo, useState, Component } from 'react';

class CardsErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Box,
  Chip,
  Typography,
  Stack,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import TimerOffOutlinedIcon from '@mui/icons-material/TimerOffOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { CustomFilterV2, TableV2 } from '../../../components/v2';
import { tableV2StackedCellContentSx } from '../../../components/v2/tableV2Styles';
import { renderStatus } from 'components/v2/cell-renderers/status';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsModuleConfiguration from '../../../store/moduleConfiguration/reducer';
import { PEDIDO_VOO_ADMIN } from '../../../constants/modules';
import { hasModuleConfiguration } from '../../../helpers/moduleConfigurationPermission';
import * as actionsPedidoVoo from '../../../store/pedidoVoo/actions';
import Formulario from './Formulario';
import AprovarDialog from './AprovarDialog';
import InvalidarDialog from './InvalidarDialog';
import ExpirarDialog from './ExpirarDialog';
import ArquivosDialog from './ArquivosDialog';
import ResumoCards from './ResumoCards';
import SisantDialog from './SisantDialog';
import {
  getPedidoVooStatusLabel,
  getCodigoPilotoSisant,
  canTransitionTo,
} from './statusLabels';

const toLocalDate = (ts) => (ts ? moment(Number(ts)).format('YYYY-MM-DD') : null);

const pedidoVooCenteredCellGridSx = {
  '& .MuiDataGrid-cell[data-field="dataFormatted"], & .MuiDataGrid-cell[data-field="inspetorNome"], & .MuiDataGrid-cell[data-field="cidade"]': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiDataGrid-cell[data-field="actions"]': {
    justifyContent: 'flex-start',
  },
};

const PedidoVoo = ({
  authData,
  deletePedidoVoo,
  validatePedidoVoo,
  updatePedidoVoo,
  findPedidoVooArquivosById,
  moduleConfigurations,
}) => {
  const hasFullAccess = useMemo(
    () => hasModuleConfiguration(moduleConfigurations, authData, PEDIDO_VOO_ADMIN),
    [moduleConfigurations, authData]
  );

  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().endOf('month').valueOf(),
    inspetorId: hasFullAccess ? null : authData?.id ? [authData.id] : null,
  });
  const [activeStatus, setActiveStatus] = useState(null);
  const [reload, setReload] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const [openAprovar, setOpenAprovar] = useState(false);
  const [openInvalidar, setOpenInvalidar] = useState(false);
  const [openExpirar, setOpenExpirar] = useState(false);
  const [invalidarPedido, setInvalidarPedido] = useState(null);
  const [openArquivos, setOpenArquivos] = useState(false);
  const [actionId, setActionId] = useState(null);

  const [openSisant, setOpenSisant] = useState(false);
  const [sisantDrone, setSisantDrone] = useState({ id: null, name: null });

  const apiFilterBase = useMemo(
    () => ({
      inspetorId: hasFullAccess ? localFilter.inspetorId || null : authData?.id ? [authData.id] : null,
      droneIds: localFilter.droneIds || null,
      cidade: localFilter.cidade || null,
      dataInicio: toLocalDate(localFilter.inicio),
      dataFim: toLocalDate(localFilter.fim),
    }),
    [localFilter, hasFullAccess, authData]
  );

  const apiFilter = useMemo(
    () => ({
      ...apiFilterBase,
      status: activeStatus ? [activeStatus] : localFilter.status || null,
    }),
    [apiFilterBase, activeStatus, localFilter.status]
  );

  const onEdit = (rowId) => {
    setOpen(true);
    setId(rowId);
  };

  const onAdd = () => {
    setOpen(true);
    setId(null);
  };

  const onClose = (save) => {
    setOpen(false);
    setId(null);
    if (save) {
      setReload(!reload);
    }
  };

  const onDelete = (rowId) => {
    deletePedidoVoo(rowId, (ok) => {
      if (ok) setReload((r) => !r);
    });
  };

  const rowActions = [
    {
      key: 'validar',
      icon: <CheckCircleOutlineIcon fontSize="small" sx={{ color: 'success.main' }} />,
      title: 'Aprovar',
      show: (row) => hasFullAccess && canTransitionTo(row.status, 'VALIDADO'),
      onClick: (rowId) => {
        setActionId(rowId);
        setOpenAprovar(true);
      },
    },
    {
      key: 'invalidar',
      icon: <NotInterestedIcon fontSize="small" sx={{ color: 'error.main' }} />,
      title: 'Negar',
      show: (row) => hasFullAccess && canTransitionTo(row.status, 'INVALIDADO'),
      onClick: (rowId, row) => {
        setInvalidarPedido(row);
        setOpenInvalidar(true);
      },
    },
    {
      key: 'expirar',
      icon: <TimerOffOutlinedIcon fontSize="small" sx={{ color: 'warning.main' }} />,
      title: 'Expirar',
      show: (row) => hasFullAccess && canTransitionTo(row.status, 'EXPIRED'),
      onClick: (rowId) => {
        setActionId(rowId);
        setOpenExpirar(true);
      },
    },
    {
      key: 'arquivos',
      icon: <AttachFileIcon fontSize="small" />,
      title: 'Ver Arquivos',
      onClick: (rowId) => {
        setActionId(rowId);
        setOpenArquivos(true);
      },
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Pedidos de Voo</Typography>

          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <CardsErrorBoundary>
          <ResumoCards
            apiFilter={apiFilterBase}
            activeStatus={activeStatus}
            onFilterByStatus={(status) => {
              setActiveStatus(status);
            }}
            refreshKey={reload}
          />
        </CardsErrorBoundary>

        <TableV2
          useApi
          fetchUrl="pedidos-voo/filter"
          rowHeight={95}
          gridSx={pedidoVooCenteredCellGridSx}
          headerActions={[
            { label: 'Novo', onClick: onAdd, startIcon: <AddIcon />, variant: 'contained' },
          ]}
          actions={rowActions}
          columns={[
            {
              field: 'dataFormatted',
              headerName: 'Data do Voo',
              width: 185,
              renderCell: ({ row }) => (
                <Box sx={tableV2StackedCellContentSx}>
                  <Typography variant="body2">{row.dataFormatted}</Typography>
                  <Typography variant="caption" component="div" sx={{ whiteSpace: 'nowrap' }}>
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Criado em:{' '}
                    </Box>
                    {row.criadoEmFormatted || '—'}
                  </Typography>
                </Box>
              ),
            },
            { 
              field: 'inspetorNome',
              headerName: 'Inspetor', 
              flex: 0.7,
              minWidth: 160,
              maxWidth: 260,
              renderCell: ({ row }) => (
                <Box sx={tableV2StackedCellContentSx}>
                  <Typography variant="body2">{row.inspetorNome}</Typography>
                  <Typography variant="caption" component="div">
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Código Sarpas:{' '}
                    </Box>
                    {getCodigoPilotoSisant(row) || '—'}
                  </Typography>
                </Box>
              ),
            },
            { 
              field: 'cidade', 
              headerName: 'Cidade', 
              flex: 0.55,
              minWidth: 200,
              maxWidth: 300,
              renderCell: ({ row }) => (
                <Box sx={tableV2StackedCellContentSx}>
                  <Typography variant="body2">{row.cidade}</Typography>
                  <Typography variant="caption" component="div">
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Latitude:{' '}
                    </Box>
                    {row.latitude}
                  </Typography>
                  <Typography variant="caption" component="div">
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Longitude:{' '}
                    </Box>
                    {row.longitude}
                  </Typography>
                </Box>
              ),
            },
            {
              field: 'drone',
              headerName: 'Drone',
              flex: 1,
              minWidth: 200,
              renderCell: ({ row }) => (
                <Box sx={{ py: 0.5, lineHeight: 1.2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                    <Typography variant="body2" component="span">{row.drone}</Typography>
                    {!row.droneCodigoSisant && (
                      <Chip
                        size="small"
                        color="warning"
                        label="Sem SISANT"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSisantDrone({ id: row.droneId, name: row.drone });
                          setOpenSisant(true);
                        }}
                        sx={{ height: 18, fontSize: '0.65rem', cursor: 'pointer' }}
                      />
                    )}
                  </Box>
                  <Typography variant="caption" component="div" sx={{ pt: 0.5 }}>
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Série:{' '}
                    </Box>
                    {row.droneNumSerie}
                  </Typography>
                  <Typography variant="caption" component="div">
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Patrimônio:{' '}
                    </Box>
                    {row.droneNumPatrimonio}
                  </Typography>
                  <Typography variant="caption" component="div">
                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                      Código SISANT:{' '}
                    </Box>
                    {row.droneCodigoSisant || '—'}
                  </Typography>
                </Box>
              ),
            },
            { field: 'protocoloAnac', headerName: 'Protocolo ANAC', width: 160 },
            {
              field: 'statusDescricao',
              headerName: 'Status',
              width: 180,
              renderCell: (params) =>
                renderStatus({
                  value: params.row.status,
                  label: getPedidoVooStatusLabel(params.row.status),
                }),
            },
          ]}
          onEdit={onEdit}
          onDelete={onDelete}
          canDelete={(row) => hasFullAccess || row.status === 'AGUARDANDO_VALIDACAO'}
          filterData={apiFilter}
          refreshKey={reload}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useDates' },
            { field: 'useInspetor', md: 12, multiSelect: true, disabled: !hasFullAccess },
            { field: 'useEquipamentoOptions', md: 12, label: 'Drones', tipoEquipamento: 'DRONE', showUsuarioTodosRepasse: !hasFullAccess },
            { field: 'useCidade', md: 12 },
            { field: 'usePedidoVooStatus', md: 12 },
          ]}
          defaultFilter={{
            inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
            fim: moment().endOf('month').valueOf(),
            inspetorId: hasFullAccess ? null : authData?.id ? [authData.id] : null,
          }}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          onReload={() => setReload((r) => !r)}
        />

        <AprovarDialog
          open={openAprovar}
          onClose={() => { setOpenAprovar(false); setActionId(null); }}
          onConfirm={(protocoloAnac) => {
            setOpenAprovar(false);
            validatePedidoVoo(actionId, { status: 'VALIDADO', protocoloAnac }, (ok) => {
              if (ok) setReload((r) => !r);
              setActionId(null);
            });
          }}
        />

        <InvalidarDialog
          open={openInvalidar}
          pedidoRow={invalidarPedido}
          onClose={() => { setOpenInvalidar(false); setInvalidarPedido(null); }}
          onConfirm={({ status, motivoRestricao, arquivos }) => {
            setOpenInvalidar(false);
            validatePedidoVoo(
              invalidarPedido.id,
              { status, motivoRestricao, arquivos },
              (ok) => {
                if (ok) setReload((r) => !r);
                setInvalidarPedido(null);
              }
            );
          }}
        />

        <ExpirarDialog
          open={openExpirar}
          onClose={() => { setOpenExpirar(false); setActionId(null); }}
          onConfirm={(motivoRestricao) => {
            setOpenExpirar(false);
            validatePedidoVoo(actionId, { status: 'EXPIRED', motivoRestricao }, (ok) => {
              if (ok) setReload((r) => !r);
              setActionId(null);
            });
          }}
        />

        <ArquivosDialog
          open={openArquivos}
          pedidoId={actionId}
          onClose={() => { setOpenArquivos(false); setActionId(null); }}
          findPedidoVooArquivosById={findPedidoVooArquivosById}
        />

        <SisantDialog
          open={openSisant}
          droneId={sisantDrone.id}
          droneName={sisantDrone.name}
          onClose={() => { setOpenSisant(false); setSisantDrone({ id: null, name: null }); }}
          onSaved={() => setReload((r) => !r)}
        />
      </Stack>
    </Box>
  );
};

PedidoVoo.propTypes = {
  authData: PropTypes.object,
  deletePedidoVoo: PropTypes.func.isRequired,
  validatePedidoVoo: PropTypes.func.isRequired,
  updatePedidoVoo: PropTypes.func.isRequired,
  findPedidoVooArquivosById: PropTypes.func.isRequired,
  moduleConfigurations: PropTypes.array,
};

PedidoVoo.defaultProps = {
  moduleConfigurations: [],
};

const mapStateToProps = (state) => ({
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsPedidoVoo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PedidoVoo));
